<template>
    <div class="pageCenter">
       <i class="iconfont icon-kongbaiye"/>
       <p>{{msg}}</p>
    </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
    export default {
        props:["msg"],

    }
</script>

<style lang="less" scoped>
@import url("../style/skin.less");
.pageCenter{
    text-align: center;
    margin-top: 20%;
    i{
        font-size: 180px;
        color: @lightP;
    }
    p{
        color:@lightP;
        font-size: 16px;
    }
}
</style>